import React, { useState } from "react";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";
import Input from "../../../components/ui/Input";
import Select from "../../../components/ui/Select";
import { Checkbox } from "../../../components/ui/Checkbox";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { getAllProductsService } from "redux/services/products_sevice";

const ProductFilters = ({ filters, onFiltersChange, onClearFilters }) => {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const [isExpanded, setIsExpanded] = useState(false);

  const stockStatusOptions = [
    { value: "all", label: t("allStockStatus") },
    { value: "in_stock", label: t("inStock") },
    { value: "low_in_stock", label: t("lowStock") },
    { value: "out_of_stock", label: t("outOfStock") },
  ];

  const priceRangeOptions = [
    { value: "all", label: t("allPrices") },
    { value: "0-25", label: t("priceRange.0-25") },
    { value: "25-50", label: t("priceRange.25-50") },
    { value: "50-100", label: t("priceRange.50-100") },
    { value: "100-500", label: t("priceRange.100-500") },
    { value: "500+", label: t("priceRange.500+") },
  ];

  const handleFilterChange = (key, value) => {
   
    dispatch(getAllProductsService({ [key]: value }));
    onFiltersChange({
      ...filters,
      [key]: value,
    });
  };

  const hasActiveFilters = () => {
    return (
      filters.search ||
      filters.stockStatus !== "all" ||
      filters.priceRange !== "all" ||
      filters.showFeatured ||
      filters.showDiscounted
    );
  };

  return (
    <div className="bg-white rounded-lg border border-border shadow-elevation-1 p-4">
      {/* Quick Filters Row */}
      <div className="flex flex-wrap items-center gap-4 mb-4">
        <div className="flex-1 min-w-64">
          <Input
            type="search"
            placeholder={t("searchPlaceholder")}
            value={filters.search}
            onChange={(e) => handleFilterChange("search", e.target.value)}
            className="w-full"
          />
        </div>

        <Select
          options={stockStatusOptions}
          value={filters.stockStatus}
          onChange={(value) => handleFilterChange("status", value)}
          placeholder={t("stockStatus")}
          className="w-40"
        />
      </div>

      {/* Active Filters Summary */}
      {hasActiveFilters() && (
        <div className="mt-4 pt-4 border-t border-border">
          <div className="flex items-center space-x-2 text-sm text-muted-foreground">
            <Icon name="Filter" size={16} />
            <span>{t("activeFilters")}</span>
            <div className="flex flex-wrap gap-2">
              {filters.search && (
                <span className="px-2 py-1 bg-primary text-primary-foreground rounded-full text-xs">
                  Search: "{filters.search}"
                </span>
              )}
              {filters.stockStatus !== "all" && (
                <span className="px-2 py-1 bg-accent text-accent-foreground rounded-full text-xs">
                  {
                    stockStatusOptions.find(
                      (opt) => opt.value === filters.stockStatus
                    )?.label
                  }
                </span>
              )}
              {filters.priceRange !== "all" && (
                <span className="px-2 py-1 bg-secondary text-secondary-foreground rounded-full text-xs">
                  {
                    priceRangeOptions.find(
                      (opt) => opt.value === filters.priceRange
                    )?.label
                  }
                </span>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductFilters;
